module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0036.jpg?v=c27312ff";